<template>
    <section id="monitor-history-datatable" 
        class="monitor-history-datatable"
    >
        <div
            v-if="show_copyright_logo"
            class="capture"
        >
            <div class="capture__text-container">
                <v-progress-circular
                    class="capture__progress"
                    indeterminate
                    size="18"
                    width="2"
                    color="black"
                />
                &nbsp;&nbsp;&nbsp;  {{ $t('__datatable.capture_text') }}
            </div>
        </div>

        <!-- 讀取資料時顯示讀取中字樣 -->
        <div
            v-if="is_loading" 
            id="history_loading"
        >
            <v-alert
                :value="true"
                class="info color_white"
                color="#3366a9"
            >
                <v-progress-circular
                    indeterminate
                    color="black"
                    class="color_white"
                />
                &nbsp;&nbsp;&nbsp;  {{ $t('__datatable.loading_text') }}
            </v-alert>
        </div>
        
        <div class="table_fixed_title">項次</div>

        <div 
            v-if="!is_loading"
            id="history_table" 
            class="history_table"
        >
            <div 
                id="history_table_left"
                class="history_table_left"
            >
                <div class="col_title">
                    項 次
                </div>
                <div 
                    v-for="(item, index) in history_item_list"
                    :key="'item' + index"
                    :id="'col_data_'+ item.item_number"
                    class="col_data"
                    :style="search && item.is_search ? 'background-color: #5d7a4b;' : get_item_bg_color(item.most_serious_light)"
                    @mouseover="set_item_tooltip_position($event, `col_data_${item.item_number}`)"
                >
                    {{ item.item_number }}

                    <div class="item_tooltip">
                        <div v-for="(column, column_index) in search_column" :key="`tooltip${column_index}`">{{ column }} : {{ item.item_description[column] }}</div>
                    </div>
                </div>
            </div>
            <div 
                id="history_table_right"
                class="history_table_right"
            >
                <div 
                    id="history_table_right_1"
                    class="history_table_right_1"
                >
                    <div 
                        id="history_table_right_2"
                        class="history_table_right_2"
                    >
                        <div class="date_row">
                            <div 
                                v-for="(date, date_index) in history_date_list"
                                :key="'date-' + date_index"
                                :style="(date_index === 0) ? 'border-left: none;' : ''"
                            >
                                {{ date }}
                            </div>
                        </div>
                        <div class="hour_row">
                            <div 
                                v-for="(i, hour_index) in history_hour_list"
                                :key="'num' + hour_index"
                                :style="(hour_index === 0) ? 'border-left: none;' : ''"
                            >
                                {{ i }}
                            </div>
                        </div>
                        <div class="data_row">
                            <!-- 項次 -->
                            <div 
                                v-for="(item, data_index_1) in history_item_list"
                                :key="'data-1' + data_index_1"
                                class="data_row_1"
                            >
                                <!-- 日期 -->
                                <div 
                                    v-for="(date, data_index_2) in history_date_list"
                                    :key="'data-2' + data_index_2"
                                    class="data_row_2"
                                >
                                    <!-- 小時 -->
                                    <div 
                                        v-for="(hour, data_index_3) in hour_list"
                                        :key="'data-3' + data_index_3"
                                        class="data_row_3"
                                        :style="(data_index_1 == 0 && data_index_2 == 0 && data_index_3 == 0) ? 'border-left: none;' : ''"
                                    >
                                        <div 
                                            :id="`data_cell_${item.item_number}_${date}_${hour}`"
                                            class="data_cell"
                                            @mouseover="set_data_tooltip_position($event, `data_tooltip_${item.item_number}_${date}_${hour}`)"
                                        >
                                            <div 
                                                v-if="history_data_obj[item.item_number][date][hour].light" 
                                                style="width: 100%; height: 100%;"
                                                :style="search && history_data_obj[item.item_number][date][hour].is_search ? 'background-color: #5d7a4b;' : ''"
                                            >
                                                <span class="data_icon">
                                                    <v-icon :class="history_data_obj[item.item_number][date][hour].icon_class">
                                                        {{ history_data_obj[item.item_number][date][hour].icon }}
                                                    </v-icon>
                                                </span>
                                            </div>
                                        </div>
                                        <div 
                                            v-if="history_data_obj[item.item_number][date][hour].alert.length > 0"
                                            class="data_tooltip"
                                            :id="`data_tooltip_${item.item_number}_${date}_${hour}`"
                                        >
                                            警示原因 <br>
                                            <div
                                                v-for="(alert, data_index_4) in history_data_obj[item.item_number][date][hour].alert"
                                                :key="'data-4' + data_index_4"
                                                class="alert_text"
                                            >
                                                <span>{{ `${alert.date_time.substring(0, 4)}-${alert.date_time.substring(4, 6)}-${alert.date_time.substring(6, 8)} ${alert.date_time.substring(8, 10)}:${alert.date_time.substring(10, 12)} ` }}</span>
                                                <span v-html="alert.alert_text" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="table__btn-container">  
            <v-btn 
                v-if="show_download_pdf_btn && !is_loading"
                class="table__btn"
                @click="download_as_pdf"
                fab
                x-small
            >
                <v-icon color="#2366f8">
                    icon-file-download
                </v-icon>
                <span class="table__btn-text">下載表格</span>
            </v-btn>
        </div>

        <!-- for 下載 PDF 功能的表格 -->
        <!-- 因為直接下載 #history_table 的話，圖是被切到的-->
        <!-- 所以準備一個沒有overflow: scroll的表格供下載使用-->
        <div
            v-show="show_download_table" 
            style="margin-top: 2000px"
        >
            <div 
                id="history_table_for_download" 
                class="history_table_for_download"
            >  
                <div
                    v-for="(date, date_index) in history_date_list"
                    :key="'date_for_download' + date_index"
                    :class="'history_table_for_download_' + date_index"
                >
                    <div class="history_table_left">
                        <div class="col_title">
                            項 次
                        </div>
                        <div 
                            v-for="(item, index) in history_item_list"
                            :key="'item' + index"
                            class="col_data"
                        >
                            {{ item.item_number }}
                        </div>
                    </div>
                    <div class="history_table_right">
                        <div class="history_table_right_1">
                            <div class="history_table_right_2">
                                <div class="date_row">
                                    <div style="border-left: none;">
                                        {{ date }}
                                    </div>
                                </div>
                                <div class="hour_row">
                                    <div 
                                        v-for="(i, hour_index) in hour_list"
                                        :key="'num' + hour_index"
                                        :style="(hour_index === 0) ? 'border-left: none;' : ''"
                                    >
                                        {{ i }}
                                    </div>
                                </div>
                                <div class="data_row">
                                    <div 
                                        v-for="(item, data_index_1) in history_item_list"
                                        :key="'data-1' + data_index_1"
                                        class="data_row_1"
                                    >
                                        <div 
                                            v-for="(hour, data_index_3) in hour_list"
                                            :key="'data-3' + data_index_3"
                                            class="data_row_3"
                                            :style="(data_index_1 == 0 && data_index_3 == 0) ? 'border-left: none;' : ''"
                                        >
                                            <div v-if="history_data_obj[item.item_number][date][hour].light" class="data_cell">
                                                <div style="width: 100%; height: 100%;">
                                                    <span class="data_icon">
                                                        <v-icon :class="history_data_obj[item.item_number][date][hour].icon_class">
                                                            {{ history_data_obj[item.item_number][date][hour].icon }}
                                                        </v-icon>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="show_copyright_logo" 
                        class="copyright"
                    >
                        <img 
                            src="/static/images/capture/blue_cwa_logo_string_eng.png"
                            class="copyright__img"
                        >
                    </div>
                    <div class="page-break" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { history_light_warning_ajax } from '@/utils/monitor/monitor.js'
import { TABLE_VALUE_TEXT_MAPPING } from '../../config/monitor_config'
import { monitor_signs_normal_mapping_css, monitor_signs_icon_name_mapping } from '@/config/monitor_config'
import html2pdf from 'html2pdf.js'

export default {
    name: 'QpeDatatableHistory',

    props: {
        // 監控產品編號 (對應到monitor_menu.json裡的value)
        default_value: {
            type: Number,
            required: true,
        },
        // 表格欄的日期清單
        history_date_list: {
            type: Array,
            default: () => [],
        },
        // 表格資料，型式為 array 中，包多個一樣 key 的 object
        data: {
            type: Array,
            default: () => [],
        },
        // 資料表標題陣列， 內部的格式為 {'text': name, 'value': name, 'order': i} 表格資料會跟隨 header
        headers: {
            type: Array,
            default: () => [],
        },
        // 是否顯示資料時間的選擇區塊，預設顯示，目前在串接上還沒有功能
        // 分鐘目前僅能選擇 10分 20分 ... 考慮到資料十分鐘一筆
        show_datetime: {
            type: Boolean,
            default: true,
        },
        // 是否顯示搜尋列，預設顯示
        show_search_bar: {
            type: Boolean,
            default: true,
        },
        show_header: {
            type: Boolean,
            default: true,
        },
        show_footer: {
            type: Boolean,
            default: false,
        },
        // 設定表格標題的背景顏色
        header_background_color: {
            type: String,
            default: '#e8ecf7',
        },
        // 設定表格標題的文字顏色
        header_text_color: {
            type: String,
            default: '#121624',
        },
        // 表格內容的，必須指定表格頁面父元件的id，才能修改傳入的顏色，用意為避免不同的表格 css 互相影響
        table_page_component_id: {
            type: String,
            default: 'monitor-table-page',
        },
        // 傳入當前使用 table 的上層 component 中文，用作下載文件 api 的參數
        name: {
            type: Number,
            require: true,
            default: -1,
        },
        // 如果有傳入，顯示錯誤訊息
        error_text: {
            type: String,
            default: '',
        },

        // 開啟點擊表格展開圖表的功能，要再上層搭配 v-slot
        enable_diagram_slot: {
            type: Boolean,
            default: false,
        },
        // 指定哪些欄位可以展開圖表
        should_draw_diagram_header: {
            type: Array,
            default: () => [],
        },
        // 指定哪些欄位滑鼠覆蓋時會顯示 tooltip
        should_display_info_header_key_value: {
            type: Object,
            default: () => ({}),
        },
        // 顯示欄位 tooltip 的邏輯 function
        generate_tooltop_display_info: {
            type: Function,
            default: () => {
                return () => {}
            },
        },
        // 讓表格可以根據傳入的規則變色，目前是只有 style 設置的 css 才有
        enable_table_label: {
            type: Boolean,
            default: false,
        },
        // 傳入表格變色的邏輯 function
        table_label_function: {
            type: Function,
            default: () => {
                return () => {}
            },
        },
        show_description_dialog_btn: {
            type: Boolean,
            default: true,
        },
        // 是否要顯示下載文件的按鈕
        show_download_doc_btn: {
            type: Boolean,
            default: false,
        },
        show_download_pdf_btn: {
            type: Boolean,
            default: false,
        },
        table_text_for_download_pdf: {
            type: String,
            default: '',
        },
        should_show_raw_html_header: {
            type: Array,
            default: () => [],
        },
        custom_header: {
            type: Boolean,
            default: false,
        },
        no_data_text: {
            type: String,
            default: '目前無資料',
        },
        search: {
            type: String,
            default: '',
        },
        search_column: {
            type: Array,
            default: ()=>{
                return ['所屬單位', '路段']
            },
        },
        show_table_border: {
            type: Boolean,
            default: false,
        },
        props_items_per_page: {
            type: Number,
            default: 100,
        },

        is_show_chart_dialog_parent: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            hour_list: [
                '00',
                '01',
                '02',
                '03',
                '04',
                '05',
                '06',
                '07',
                '08',
                '09',
                '10',
                '11',
                '12',
                '13',
                '14',
                '15',
                '16',
                '17',
                '18',
                '19',
                '20',
                '21',
                '22',
                '23',
            ],
            history_item_list: [], // 列標題資料的清單容器
            history_hour_list: [], // 欄標題小時的清單
            history_data_obj: {}, // 表格資料的容器
            // history_sign_data: [], // 如果有要算sign個數之後再加

            // for 下載pdf
            show_copyright_logo: false,
            show_download_table: false,

            // 表格是否正在處理
            is_loading: true,
        }
    },

    computed: {},

    async mounted() {
        await this.get_data()
    },

    watch: {
        history_date_list: {
            handler() {
                this.get_data()
            },
            deep: true,
        },

        search: {
            handler(newValue) {
                this.history_item_list.forEach((item) => {
                    const search = this.search_column.filter(column => {
                        return item.item_description[column] && item.item_description[column].includes(newValue)
                    }).length
                    item.is_search = search

                    this.history_date_list.forEach((d) => {
                        this.hour_list.forEach((h) => {
                            let table_cell = this.history_data_obj[item.item_number][d][h]
                            table_cell.is_search =
                                table_cell.alert.filter(
                                    (a) =>
                                        a.alert_text.includes(newValue) ||
                                        `${a.date_time.substring(0, 4)}-${a.date_time.substring(
                                            4,
                                            6
                                        )}-${a.date_time.substring(6, 8)} ${a.date_time.substring(
                                            8,
                                            10
                                        )}:${a.date_time.substring(10, 12)}`.includes(newValue)
                                ).length > 0
                        })
                    })
                })
            },
        },
    },

    methods: {
        async get_data() {
            this.is_loading = true
            this.get_history_hour_list()
            if(!this.history_date_list.length) return

            let start_time = `${this.history_date_list[0]} 00:00:00`
            let end_time = `${this.history_date_list[this.history_date_list.length - 1]} 23:59:59`
            
            let API_data = await history_light_warning_ajax.call(this, this.default_value, start_time, end_time)
            // 取得項次清單
            this.history_item_list = API_data.data.map((x) => {
                return {
                    item_number: Object.keys(x)[0],
                    item_description: { ...x[Object.keys(x)[0]].item_description },
                    is_search: false,
                    most_serious_light: null,
                }
            })

            // 建立裝資料的容器
            const data_obj = {}
            this.history_item_list.forEach((item) => {
                data_obj[item.item_number] = {}

                this.history_date_list.forEach((d) => {
                    data_obj[item.item_number][d] = {}

                    this.hour_list.forEach((h) => {
                        data_obj[item.item_number][d][h] = {}
                        data_obj[item.item_number][d][h].light = null
                        data_obj[item.item_number][d][h].alert = []
                        data_obj[item.item_number][d][h].is_search = false
                        data_obj[item.item_number][d][h].icon_class = ''
                        data_obj[item.item_number][d][h].icon = ''
                    })
                })
            })

            this.history_item_list.forEach((item) => {
                // 開始放資料進去
                let alert = API_data.data.filter((d) => d[item.item_number])[0][item.item_number].alert
                let light = API_data.data.filter((d) => d[item.item_number])[0][item.item_number].light
                let alert_keys = Object.keys(alert)
                let light_keys = Object.keys(light)

                light_keys.forEach((l_key) => {
                    let date = `${l_key.substring(0, 4)}-${l_key.substring(4, 6)}-${l_key.substring(6, 8)}`
                    let hour = `${l_key.substring(8, 10)}`

                    if (this.history_date_list.includes(date)) {
                        const light_level = light[l_key]
                        data_obj[item.item_number][date][hour].light = light_level
                        data_obj[item.item_number][date][hour].icon_class = this.get_light_icon_class(light_level)
                        data_obj[item.item_number][date][hour].icon = this.get_light_icon(light_level)

                        // 為了取得特定項次中最嚴重的燈號
                        this.history_item_list.forEach((x) => {
                            if (x.item_number == item.item_number) {
                                if (!x.most_serious_light || x.most_serious_light > light[l_key]) {
                                    x.most_serious_light = light[l_key]
                                }
                            }
                        })
                        // 如果有要算sign個數之後再加
                        // this.history_sign_data.push({
                        //     idx: item.item_number,
                        //     signs_num: light[l_key]
                        // })

                        data_obj[item.item_number][date][hour].alert = []
                        // alert 中所有包含此日期及小時的 key
                        let alert_time_key_list = alert_keys.filter((k) => k.includes(l_key.substring(0, 10)))
                        alert_time_key_list.forEach((a_key) => {
                            data_obj[item.item_number][date][hour].alert.push({
                                date_time: a_key,
                                alert_text: alert[a_key],
                            })
                        })
                    }
                })
            })

            // 如果有要算sign個數之後再加
            // this.$emit('set_history_sign_data', this.history_sign_data);

            this.history_data_obj = data_obj
            this.is_loading = false
        },

        get_history_hour_list() {
            let list = []
            let i = this.history_date_list.length
            while (i != 0) {
                list.push(...this.hour_list)
                --i
            }
            this.history_hour_list = list
        },

        get_hour_data(item_number, date, hour) {
            return this.history_data_obj?.[item_number]?.[date]?.[hour] || null
        },

        get_light_icon_class(light) {
            return monitor_signs_normal_mapping_css?.[light] || ''
        },
        
        get_light_icon(light) {
            return monitor_signs_icon_name_mapping?.[light] || ''
        },

        get_item_bg_color(light) {
            return light === 1
                ? 'background-color: #ee3934;'
                : light === 2
                    ? 'background-color: #eda12f;'
                    : light === 3
                        ? 'background-color: #f1d94a;'
                        : ''
        },

        set_item_tooltip_position(event, element_id) {
            const mouse_x = event.clientX + 20
            const mouse_y = event.clientY

            const tooltip = document.getElementById(element_id).querySelector('.item_tooltip')
            if(!tooltip) return 

            tooltip.setAttribute('style', `left: ${mouse_x}px; top: ${mouse_y}px;`)
        },

        set_data_tooltip_position(event, element_id) {
            const w = document.getElementById('history_table_right').offsetWidth * 0.6
            const h = document.body.clientHeight * 0.6

            let mouse_x = event.clientX < w ? event.clientX + 20 : event.clientX - 330
            let mouse_y = event.clientY

            const tooltip = document.getElementById(element_id)
            if(!tooltip) return 
            
            if (event.clientY < h) {
                tooltip.setAttribute('style', `left: ${mouse_x}px; top: ${mouse_y}px;`)
            } else {
                tooltip.setAttribute('style', `left: ${mouse_x}px; bottom: calc(100vh - ${mouse_y}px);`)
            }
        },

        download_as_pdf() {
            this.show_download_table = true
            this.show_copyright_logo = true
            const start_date = this.history_date_list[0]
            const end_date = this.history_date_list[this.history_date_list.length - 1]
            const table_text = `${
                TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']
            }資訊-歷史燈號(${start_date}~${end_date})`

            const options = {
                margin: 5,
                pagebreak: { before: ['.page-break'] },
                filename: `${table_text}.pdf`,
                jsPDF: { orientation: 'l' }, // PDF橫向
            }

            this.$nextTick(() => {
                const table = document.querySelectorAll('.history_table_for_download')
                let download_worker = html2pdf()
                    .set(options)
                    .from(table[0])
                    .toPdf()
                ;[...table].slice(1).forEach((t) => {
                    download_worker = download_worker
                        .get('pdf')
                        .then((pdf) => pdf.addPage())
                        .from(t)
                        .toContainer()
                        .toCanvas()
                        .toPdf()
                })
                download_worker.save().then(() => {
                    this.show_copyright_logo = false
                    this.show_download_table = false
                })
            })
        },
    },
}
</script>

<style lang="scss" scoped>
/* @import url('../../../css/custom_qpe_datatable.css'); */
#monitor-history-datatable {
    position: relative;
    padding: 0 1rem;
    width: 100%;
    // max-height: 60vh;
}

// 左上固定標題
.table_fixed_title {
    position: absolute;
    height: 60px;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #aaa;
    font-size: 14px;
    box-sizing: border-box;
    writing-mode: vertical-lr;
    letter-spacing: 2px;
    background-color: #fafafa;
    z-index: 2;
}

.history_table {
    position: relative;
    display: flex;
    text-align: center;
    padding-bottom: 50px;
    height: calc(100vh - 250px - 50px);
    overflow: scroll;
}

.history_table_left {
    position: sticky;
    width: 40px;
    flex: 0 0 40px;
    left: 0;
    z-index: 1;

    .col_title {
        height: 60px;
        line-height: 37px;
        border: 1px solid #aaa;
        font-size: 14px;
        box-sizing: border-box;
        writing-mode: vertical-lr;
    }

    .col_data {
        position: relative;
        height: 30px;
        line-height: 30px;
        border: 1px solid #aaa;
        border-top: none;
        font-size: 14px;
        background-color: #fafafa;

        .item_tooltip {
            display: none;
            position: fixed;
            z-index: 10;

            min-width: 100px;
            max-width: 350px;
            padding: 5px 10px;
            background-color: #bfbfbf;
            border-radius: 5px;
            text-align: left;
        }
    }

    .col_data:hover .item_tooltip {
        display: inline-block;
    }
}

.history_table_right {
    .history_table_right_1 {
        .history_table_right_2 {
            display: flex;
            flex-direction: column;

            .date_row {
                position: sticky;
                display: inline-flex;
                justify-content: flex-start;
                top: 0;
                background-color: #fafafa;
                z-index: 1;

                div {
                    // display: inline-block;
                    border-top: 1px solid #aaa;
                    border-right: 1px solid #aaa;
                    border-bottom: 1px solid #aaa;
                    box-sizing: border-box;
                    min-width: 720px;
                    height: 30px;
                    line-height: 30px;
                    font-size: 14px;
                }
            }

            .hour_row {
                position: sticky;
                display: inline-flex;
                justify-content: flex-start;
                top: 30px;
                background-color: #fafafa;
                z-index: 1;

                div {
                    // display: inline-block;
                    border-right: 1px solid #aaa;
                    border-bottom: 1px solid #aaa;
                    box-sizing: border-box;
                    min-width: 30px;
                    height: 30px;
                    line-height: 30px;
                    font-size: 14px;
                }
            }

            .data_row_1 {
                display: flex;
            }

            .data_row_2 {
                display: flex;
                min-width: 720px;
                height: 30px;
            }

            .data_row_3 {
                // display: inline-block;
                border-right: 1px solid #aaa;
                border-bottom: 1px solid #aaa;
                box-sizing: border-box;
                min-width: 30px;
                height: 30px;
                line-height: 30px;
                font-size: 14px;
                text-align: center;

                .data_cell {
                    position: relative;
                    max-width: 30px;
                    height: 29px;
                    box-sizing: border-box;
                }
                .data_tooltip {
                    display: none;
                    position: fixed;
                    z-index: 10;

                    min-width: 100px;
                    max-width: 350px;
                    padding: 5px 10px;
                    background-color: #bfbfbf;
                    border-radius: 5px;

                    font-size: 14px;
                    text-align: left;
                }

                .data_cell:hover + .data_tooltip {
                    display: inline-block;
                }
            }
        }
    }
}

.history_table_for_download {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
}

[class^='history_table_for_download_'] {
    position: relative;
    display: flex;
    margin-top: 5px;
}

.capture {
    position: fixed;
    top: 50%;
    left: 40%;
    transform: translate(-50%, -50%);
    padding: 0.3rem 0.2rem 0.3rem 0.3rem;
    line-height: 40px;
    text-align: center;
    background-image: linear-gradient(to right, #2366f8 0%, #2cfde1 100%);
    border-radius: 0.5rem;
    z-index: 1;
    box-shadow: 0 0 5px #888;

    &__text-container {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 1rem;
        font-size: 14px;
        background-color: #fff;
        border-radius: 0.5rem;
    }

    &__progress {
        margin-right: 0.5rem;
    }
}

.copyright {
    position: absolute;
    top: 150px;
    left: 300px;
    display: flex;
    flex-direction: column;

    &__img {
        width: 10rem;
    }
}

// 五邊形
.signal--warning {
    margin-top: -5px;
    color: var(--base-yellow);
    max-width: 25px;
    max-height: 25px;
}

// 菱形
.signal--alert {
    margin-top: -5px;
    transform: scale(0.75) rotate(45deg);
    color: var(--base-orange);
    transition: none;
    max-width: 25px;
    max-height: 25px;
}

// 三角形
.signal--action {
    margin-top: -5px;
    transform: scale(0.9) translateX(-2.5%);
    color: var(--base-red);
    transition: none;
    max-width: 25px;
    max-height: 25px;
}
</style>
